import { Select } from "antd";
import { Bloodhound } from "extensions/bloodhound";
import levenshtein from "js-levenshtein";
import { Component } from "react";

import { references } from "common/helpers/references";
import { merchantNameNormalizer } from "common/utils";

export class MerchantSelect extends Component {
    static defaultProps = {
        merchant_ref: void 0,
        onChange: () => {}
    };
    
    constructor(props) {
        super(props);
        this.initializeMerchantsEngine();
        this.state = {
            merchants_data: [],
            merchant_value: props.merchant_ref && {
                key: props.merchant_ref
            }
        };
    }
    
    componentDidMount() {
        // Set initial merchants list
        try {
            this.setState({
                merchants_data: JSON.parse(localStorage.getItem("recent-merchants")).map((id) => ({
                    value: id,
                    text: references.toAlias(id, "merchant")
                }))
            });
        } catch {
            // noop
        }
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (this.state.merchant_value?.key !== prevState.merchant_value?.key) {
            this.props.onChange(this.state.merchant_value?.key, prevState.merchant_value?.key);
        }
    }
    
    findMerchant = (query = "") => {
        this.merchantsEngine.search(query, (datums) => {
            this.setState({
                merchants_data: datums.map(({ id, display_name }) => ({
                    value: id,
                    text: display_name
                }))
            });
        });
    };
    
    handleMerchantChange = (value) => {
        this.setState({
            merchant_value: value
        });
    };
    
    initializeMerchantsEngine() {
        this.merchantsEngine = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace(["normalized_name", "display_name", "id"]),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            local: references.getAliasGroupByType("merchant").map((m) => ({
                id: m.id,
                display_name: m.display_name,
                normalized_name: merchantNameNormalizer(m.display_name)
            })),
            identify: (obj) => obj.id,
            sorter: (a, b) => levenshtein(a.display_name, this.merchantsEngine.lastQuery) - levenshtein(b.display_name, this.merchantsEngine.lastQuery),
            sufficient: 10
        });
    }
    
    render() {
        return (
            <Select
                showSearch
                allowClear
                labelInValue
                filterOption={false}
                value={this.state.merchant_value}
                placeholder="Select a merchant"
                onSearch={this.findMerchant}
                onChange={this.handleMerchantChange}
                style={{ width: "400px" }}
            >
                {this.state.merchants_data.map((d) => (
                    <Select.Option key={d.value}>{d.text}</Select.Option>
                ))}
            </Select>
        );
    }
}
